import PropTypes from "prop-types";
import React from "react";

const IsMobileContext = React.createContext(false);

const IsMobileProvider = props => {
  const [isMobile, setIsMobile] = React.useState(props.isMobile);

  React.useEffect(() => {
    if (props.isMobile !== isMobile) {
      setIsMobile(props.isMobile);
    }
  }, [props.isMobile]);

  return <IsMobileContext.Provider value={isMobile}>{props.children}</IsMobileContext.Provider>;
};

IsMobileProvider.defaultProps = {
  isMobile: false,
};
IsMobileProvider.propTypes = {
  isMobile: PropTypes.bool,
  children: PropTypes.any,
};
export { IsMobileProvider };

export default IsMobileContext;
